import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VisitUpdateService {
  private visitUpdatedSource = new Subject<void>();
  
  visitUpdated$ = this.visitUpdatedSource.asObservable();

  notifyVisitUpdated(): void {
    this.visitUpdatedSource.next();
  }
}